export default __webpack_public_path__ + "static/media/lotus.f651401c.svg";